import React from 'react';
import EventListItem from '../list/EventListItem';

/**
 * NoteEvent - Renders a note event
 */
function NoteEvent({
  note,
  onEventClick,
  onDeleteClick,
  disabled
}) {
  return (
    <EventListItem
      event={note}
      onClick={onEventClick}
      onDelete={onDeleteClick}
      disabled={disabled}
    />
  );
}

export default React.memo(NoteEvent);
